import * as serviceContext from '../services/serviceContext';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getAgentsList() {
    try {
        const response = await serviceContext.get(`masterAgent/agents/list`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function addAgent(data) {
    try {
        const response = await serviceContext.post("masterAgent/agents", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function updateAgents(data) {
    try {
        const response = await serviceContext.put("masterAgent/agents", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function agentCheckname(username) {
    try {
        const response = await serviceContext.get(`masterAgent/agents/checkname/${username}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function activeDeactiveAgent(username, activate = false) {
    try {
        const response = await serviceContext.post(`masterAgent/agents/${activate ? 'activate' : 'deactivate'}/${username}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getAgentDetail(username) {
    try {
        const response = await serviceContext.get("manage/users/detail/"+username, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
